export const DRAG_TYPES = {
    TRANSCRIPT_BLOCK: 'transcript-block',
};
